import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'; // Importing Font Awesome icons

export function JobPosting() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className="bg-adminbg h-full contentAdmin p-4" style={{ fontFamily: "Inter, sans-serif" }}>
      <div className="">
        <div className="w-full my-5 bg-white rounded-md ">
          <div className="flex justify-between items-center border-b p-4">
            <h2 className="text-2xl text-black font-semibold">Job Shifts</h2>
            <div className="flex gap-3">
              <Button colorScheme="blue" fontSize="medium" onClick={onOpen}>
                Add <i className="fa-solid fa-plus px-2"></i>
              </Button>
              <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <div className="p-4">
                    <h4 className="text-lg font-medium mb-4">Add Shifts:</h4>
                    <Input
                      placeholder="Shift Title"
                      _placeholder={{ color: "gray.500" }}
                      mb={4}
                    />
                    <div className="flex justify-center gap-2">
                      <Button colorScheme="blue" className="w-64">
                        Save
                      </Button>
                      <Button
                        colorScheme="blue"
                        variant="outline"
                        className="w-64"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>

          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="text-left">ID</Th>
                  <Th className="text-left">Title</Th>
                  <Th className="text-left">Status</Th>
                  <Th className="text-left">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>1</Td>
                  <Td>Morning Shift</Td>
                  <Td textColor="green">Active</Td>
                  <Td>
                    <div className=" text-sm opacity-90 text-blue-700">
                      <i class="fa-solid fa-eye mr-3.5 "></i>
                      <i class="fa-solid fa-pencil mr-3.5 "></i>
                      <i class="fa-solid fa-trash-can-arrow-up mr-3.5 "></i>
                    </div>
                  </Td>
                </Tr>
                {/* Add more rows as needed */}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
